<template>
  <div>
    <!--begin::Header -->
    <div
      class="d-flex flex-column flex-center py-10 bgi-size-cover bgi-no-repeat rounded-top border"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <h4 class="text-white font-weight-bold">
        <span dir="ltr" class="mx-2" :class="{ 'text-danger': balance < 0 }">
          {{ numberFormat(balance) }}
        </span>
        <span class="font-size-md"> تومان </span>
      </h4>
      <b-button
        v-b-modal.wallet-modal
        class="btn btn-primary btn-sm font-weight-bold text-white font-size-sm mt-3 add-charge"
      >
        افزودن موجودی
      </b-button>
      <b-modal
        id="wallet-modal"
        header-class="border-0"
        hide-footer
        centered
        title="افزایش اعتبار حساب کاربری"
      >
        <form>
          <div>
            <b-form-group label="انتخاب کنید:" v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="reCharge"
              >
                افزایش شارژ
              </b-form-radio>
              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="giftCard"
              >
                افزایش شارژ با کد هدیه
              </b-form-radio>
            </b-form-group>
          </div>
          <div v-if="selected === `reCharge`">
            <div class="form-group">
              <label class="font-size-h6 font-weight-bolder text-dark">
                مبلغ
              </label>
              <input
                type="text"
                name="value"
                v-model="form.value"
                maxlength="13"
                autocomplete="off"
                @keyup="showText"
                class="form-control form-control-solid text-center h-auto p-5 rounded-lg"
                style="letter-spacing: 0.2rem"
              />
              <span class="form-text text-muted">{{ form.valueText }}</span>
            </div>

            <div class="mb-10 mt-3 d-flex flex-wrap justify-content-center">
              <div v-for="(gateway, i) in gateWays" :key="i" class="m-2">
                <div class="symbol symbol-75 text-center">
                  <img
                    class="mx-auto"
                    :class="{ selected_gateway: gateway === selectedGateway }"
                    :alt="gateway"
                    :src="`/media/gateways/${gateway}.png`"
                    @click="selectedGateway = gateway"
                  />
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <button
                type="button"
                ref="pay_btn"
                class="btn btn-primary"
                :disabled="form.value === ''"
                @click="pay"
              >
                پرداخت
              </button>
              <button
                type="button"
                class="btn btn-danger mx-2"
                @click="$bvModal.hide('wallet-modal')"
              >
                بستن
              </button>
            </div>
          </div>
          <div v-if="selected === `giftCard`">
            <div class="form-group">
              <label class="font-size-h6 font-weight-bolder text-dark">
                کد
              </label>
              <input
                type="text"
                name="value"
                v-model="form.code"
                maxlength="13"
                autocomplete="off"
                @keyup="showText"
                class="form-control form-control-solid text-center h-auto p-5 rounded-lg"
                style="letter-spacing: 0.2rem"
              />
              <span class="form-text text-muted">{{ form.valueText }}</span>
            </div>
            <vue-hcaptcha
              v-if="hCaptcha.render"
              :sitekey="hCaptcha.siteKey"
              language="fa"
              @verify="onVerify"
              @expired="onExpire"
              @challengeExpired="onExpire"
              @error="onError"
            ></vue-hcaptcha>

            <div class="mt-10 d-flex justify-content-center">
              <button
                :disabled="hCaptcha.verified !== true"
                type="button"
                ref="submit_btn"
                class="btn btn-primary"
                @click="submit"
              >
                ثبت
              </button>
              <button
                type="button"
                class="btn btn-danger mx-2"
                @click="$bvModal.hide('wallet-modal')"
              >
                بستن
              </button>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
    <!--end::Header -->

    <!--begin::Nav -->
    <div class="row row-paddingless">
      <!--begin:Item-->
      <template v-for="(item, i) in list">
        <router-link
          :to="{
            name: item.link
          }"
          class="col-4"
          v-bind:key="i"
        >
          <div
            class="d-block py-10 px-5 text-center bg-hover-light border-right max-h-135px"
          >
            <span class="svg-icon svg-icon-3x svg-icon-primary">
              <!--begin::Svg Icon-->
              <inline-svg :src="item.svg" />
              <!--end::Svg Icon-->
            </span>
            <span
              class="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1"
            >
              {{ item.title }}
            </span>
          </div>
        </router-link>
      </template>
      <!--end:Item-->
    </div>
    <!--end::Nav -->
  </div>
</template>
<style>
.selected_gateway {
  border: 2px solid #223047;
}
.add-charge:hover {
  color: #000000 !important;
}
</style>
<script>
import { mapGetters } from "vuex";
import Num2persian from "num2persian";
import ApiService from "@/core/services/api.service";
import { GET_GATWAYS } from "@/core/services/store/profile.module";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import { STORE_GIFT_CARDS } from "@/core/services/store/prices.module";
import Swal from "sweetalert2";

export default {
  name: "KTDropdownQuickAction",
  data() {
    return {
      hCaptcha: {
        siteKey: process.env.VUE_APP_HCAPTCHA_SITE_KEY,
        render: true,
        verified: false,
        expired: false,
        token: null,
        eKey: null,
        error: null
      },
      selected: "reCharge",
      form: {
        value: "",
        code: "",
        valueText: ""
      },
      list: [
        {
          title: "تراکنش‌ها",
          link: "transactions-index",
          svg: process.env.BASE_URL + "media/svg/icons/Shopping/Money.svg"
        },
        {
          title: "رسید‌ برنامه‌",
          link: "receipts-lives-index",
          svg: process.env.BASE_URL + "media/svg/icons/General/Clipboard.svg"
        },
        {
          title: " رسید‌ فایل",
          link: "receipts-storage-index",
          svg: process.env.BASE_URL + "media/svg/icons/General/Clipboard.svg"
        }
      ],
      selectedGateway: "mellat",
      gateways: {
        mellat: 1
      }
    };
  },
  components: {
    VueHcaptcha
  },
  mounted() {
    this.$store.dispatch(GET_GATWAYS);
  },
  computed: {
    ...mapGetters([
      "gateWays",
      "currentUserWallets",
      "currentUserActiveWalletId"
    ]),

    balance() {
      if (this.currentUserWallets[0]) {
        return parseInt(this.currentUserWallets[0].balance / 10);
      }
      return 0;
    },
    backgroundImage() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    }
  },
  methods: {
    showText() {
      let number = this.parseNumbers(this.form.value);

      this.form.value = Intl.NumberFormat().format(number);

      this.form.valueText =
        Math.floor(number / 10) !== 0
          ? Num2persian(Math.floor(number / 10)) + " تومان"
          : "";
    },
    pay() {
      let tokens = {};
      let tatoken = this.getCookie("tatoken");
      if (tatoken) {
        tokens["tatoken"] = tatoken;
      }
      let payBtn = this.$refs.pay_btn;
      this.disableBtn(payBtn);
      ApiService.post(
        `gateways/${this.gateWays.indexOf(this.selectedGateway) + 1}/payment`,
        { 
          amount: parseInt(this.parseNumbers(this.form.value)),
          wallet: this.currentUserActiveWalletId,
          tokens
        }
      )
        .then(({ data }) => {
          this.enableBtn(payBtn);
          let form = document.createElement("form");
          form.method = "POST";
          form.action = data.url;
          let element1 = document.createElement("input");
          element1.value = data.reference;
          element1.name = "RefId";

          form.appendChild(element1);
          document.body.appendChild(form);

          form.submit();
        })
        .catch(() => {
          this.enableBtn(payBtn);
        });
    },
    onVerify(token, eKey) {
      this.hCaptcha.verified = true;
      this.hCaptcha.token = token;
      this.hCaptcha.eKey = eKey;
    },
    onExpire() {
      this.hCaptcha.verified = false;
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.expired = true;
    },
    onError(err) {
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.error = err;
    },
    submit() {
      let captcha = this.hCaptcha.token;

      const submitButton = this.$refs["submit_btn"];
      this.disableBtn(submitButton);

      this.$store
        .dispatch(STORE_GIFT_CARDS, {
          code: this.form.code,
          captcha: captcha
        })
        .then(() => {
          this.enableBtn(submitButton);
          Swal.fire({
            icon: "success",
            title: "عملیات با موفقیت انجام شد",
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(e => {
          if (e.status === 404) {
            Swal.fire({
              title: "",
              text: "کد وارد شده صحیح نیست",
              icon: "error",
              showCloseButton: false,
              confirmButtonText: "بستن",
              confirmButtonColor: "#4554a0",
              heightAuto: false
            });
          } else if (e.status === 422) {
            Swal.fire({
              title: "",
              text: e.data.error,
              icon: "error",
              showCloseButton: false,
              confirmButtonText: "بستن",
              confirmButtonColor: "#4554a0",
              heightAuto: false
            });
          }
          this.enableBtn(submitButton);
        });
    }
  }
};
</script>
